import emptySplitApi from "../utils/rtk";
import { CommonBody, CustomerSupportResponse } from "../types/General";
import { END_POINTS } from "../constants/urls";


type CommonResponseType = {
    status: number;
    message: string;
};

type GetCustomerSupportModule = {
  length: number;
  start: number;
  response_object: CustomerSupportResponse[];
  total_records: number;
  from_date?: string;
  to_date?: string;
};

export const customerSupportApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        queryList: builder.mutation<
            CommonResponseType & { data: GetCustomerSupportModule },
            CommonBody
        >({
            query: (body) => ({
                url: END_POINTS.getQueries,
                method: "POST",
                body,
            }),
        }),
        deleteQuery: builder.query<
            CommonResponseType & { data: CustomerSupportResponse },
            { id: number | null }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.deleteQuery}${id}/`,
                method: "DELETE",
            }),
        }),
        revertQuery: builder.mutation<
            CommonResponseType & { data: CustomerSupportResponse },
            { body: CommonBody, id: number | null }
        >({
            query: ({ body, id }) => ({
                url: `${END_POINTS.revertQuery}${id}/`,
                method: "POST",
                body,
            }),
        }),
        queryById: builder.query<
            CommonResponseType & { data: CustomerSupportResponse },
            { id: number | null }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.queryById}${id}/`,
                method: "GET",
            }),
        }),
    }),
});

export const {
    useQueryListMutation,
    useLazyDeleteQueryQuery,
    useRevertQueryMutation,
    useLazyQueryByIdQuery
} = customerSupportApi;
